import assign from 'lodash/assign';
import { globalStore } from 'stores';
import { messenger, user } from 'lib';

let roomId = 0;

let roomInfo = {};

const init = (id, info) => {
  roomInfo = assign(
    {
      hostId: 0,
    },
    info,
  );
  roomId = id;

  messenger.setParentActions({
    getRoomId,
    getRoomInfo,
  });
};

const getRoomId = () => {
  return roomId;
};

const getRoomType = () => {
  return roomInfo.roomType;
};

const getRoomInfo = () => {
  return roomInfo;
};

const isHost = (userId) => {
  if (userId) {
    return roomInfo.hostId === userId;
  }
  const { isLogin, userInfo } = globalStore;
  if (isLogin) {
    return roomInfo.hostId === userInfo._id;
  }

  return false;
};

const isRoomOwner = () => {
  return roomId === globalStore.userId;
};

// 需要在不同房间重写
const isMicStar = (starId) => {
  return false;
};

// 需要在不同房间重写
const isAdmin = (userId) => {
  return false;
};

const isPartyRoom = () => {
  return roomInfo.roomType === 6;
};

export default {
  init,
  getRoomId,
  getRoomType,
  isHost,
  isMicStar,
  isRoomOwner,
  isPartyRoom,
  isAdmin,
};
